import React, { useState } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { Spinner, Title } from "../../atoms";
import AcceptIcon from "../../../assets/images/accept-icon.svg";

export const ConfirmationModal = ({ isOpen,  onConfirm, setClose, title, content, subContent, isLoading  }) => {
    
    //const[close, setClose] = useState(false);
    const[open, setOpen] = useState(isOpen);

    return (
        <Modal open={isOpen} showCloseIcon={false} center onClose={setClose} >
            <form
            onSubmit={(e) => {
                e.preventDefault();
                onConfirm();
            }}
            >
                <div>
            <div className="boxImgDiv">     
            <img src={AcceptIcon} />        
              <Title text={title} className={"titleDefaultCls"} />
            </div>
            <Title text={content} className="boxContent" />
            
            <Title text={subContent} className="boxContent" />
          </div>

          <div
          style={{
            display: "flex",
            marginTop: 20,
            justifyContent: "space-around",
          }}
        >
          <button type="button" onClick={setClose} className="boxCancelBtn text">
            Cancel
          </button>
          {isLoading ? (
            <div className="spinnerContainer">
              <Spinner color={"black"} loading={isLoading} size={20} />
            </div>
          ) : (
            <button type="submit" className="boxDelBtn text" id="para1">
              Proceed
            </button>
          )}
        </div>
            </form>
        </Modal>
    );
};

export default ConfirmationModal